const subscription = state => state?.subscription;
const offers = state => state?.subscription?.offers;
const subscriptions = state => state?.subscription?.subscriptions;
const error = state => state?.subscription?.error;
const selections = state => state?.subscription?.selections;
const submitted = state => state?.subscription?.submitted;

export { subscription, subscriptions, error, offers, selections, submitted };
